import { render, staticRenderFns } from "./VehicleListSideMenu.vue?vue&type=template&id=2425659a"
import script from "./VehicleListSideMenu.vue?vue&type=script&lang=js"
export * from "./VehicleListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2425659a')) {
      api.createRecord('2425659a', component.options)
    } else {
      api.reload('2425659a', component.options)
    }
    module.hot.accept("./VehicleListSideMenu.vue?vue&type=template&id=2425659a", function () {
      api.rerender('2425659a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vehicle/VehicleListSideMenu.vue"
export default component.exports